// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDAAPVnX2MqEFWNPwJqCeOntNDXrjcpCMA",
  authDomain: "peopletag-demo-1.firebaseapp.com",
  projectId: "peopletag-demo-1",
  storageBucket: "peopletag-demo-1.firebasestorage.app",
  messagingSenderId: "510075152291",
  appId: "1:510075152291:web:1689c1fa956b359479dc16",
  measurementId: "G-BSGPFR5Z8M"
};

const app = initializeApp(firebaseConfig);

// Initialize Firestore - use named database "aidrivenlabs"
const db = getFirestore(app, 'aidrivenlabs');

// Initialize Auth
const auth = getAuth(app);

// Initialize Storage
const storage = getStorage(app);

export { db, auth, storage };

